import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import { connect } from "react-redux";

import { Dispatch, StoreState } from "../store";
import { AreaType } from "../types/index";
import AreaTypeFilter from "./AreaTypeFilter";

function mapStateToProps({ marketShareFilter }: StoreState) {
  return {
    marketShareFilter,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    changeMarketShareFilter: (payload: any) =>
      dispatch.marketShareFilter.changeMarketShareFilter(payload),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class CustomerGroupFilterMarketShare extends React.Component<
  Props & StyledComponentProps
> {
  public render() {
    const { classes, marketShareFilter } = this.props;

    return (
      <Paper className={classes && classes.paper}>
        <Typography variant="h6">Kundengruppenfilter</Typography>
        <Grid
          className={classes && classes.content}
          container={true}
          spacing={2}
        >
          <Grid item={true} xs={12} md={6}>
            <Grid container={true} spacing={2}>
              <Grid item={true} xs={12}>
                <AreaTypeFilter
                  onChange={this.handleAreaTypeChange}
                  areaType={marketShareFilter.areaType}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }

  private handleAreaTypeChange = (areaType: AreaType[]) => {
    this.props.changeMarketShareFilter({
      areaType,
    });
  };
}
const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  content: {
    "margin-top": theme.spacing(1),
  },
  divWidth: { width: "100%" },
  paper: {
    padding: theme.spacing(2),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CustomerGroupFilterMarketShare));



// WEBPACK FOOTER //
// ./src/components/CustomerGroupFilterMarketShare.tsx